import React from 'react';
import { useParams } from 'react-router-dom';
import { popupOpenService } from "./popupOpenService";
import { useTranslation } from 'react-i18next';
import { RestoreIcon } from './RestoreIcon';
import { Tooltip } from './Tooltip';

const RestoreItemIcon = ({ itemId, popupKey }) => {
    const { i18n } = useTranslation();
    const { tab } = useParams();

    const openRestorePopup = () => {
        popupOpenService.callToOpen(popupKey, itemId);
    };

    return (
        <Tooltip content={i18n.t(`app.page.${tab}.hint`)} placement="top-end">
            <div key={itemId + 'deleteIcon'} onClick={openRestorePopup}>
                <RestoreIcon nameOfClass="product__list-icon" />
            </div>
        </Tooltip>
    );
};

export default RestoreItemIcon;
